import { ColorGrid } from '@laranda/lib-sysutil';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { DameSistemas, DameStatusCasos, DameCasos, AutenticaCli } from '@laranda/lib-ucontrol';
import { SysFecha, HTfech_a_fech, fech_a_HTfech, fechaHoy, inicio_anno, HTfechaHoy } from '@laranda/lib-sysutil';
import swal from 'sweetalert2';
@Component({
  selector: 'app-ctrl-casos',
  templateUrl: './ctrl-casos.component.html',
  styleUrls: ['./ctrl-casos.component.scss']
})
export class CtrlCasosComponent implements OnInit {

  desde: string;
  hasta: string;
  fSistema: FormControl = new FormControl(0);
  sysFecha = new SysFecha();
  dtColumnas: DataTables.ColumnSettings[];
  frmStatCasos: FormGroup = new FormGroup({});

  IconTabla: DataTables.FunctionColumnRender = ( data, type, row, meta ) => {
    if (type === 'display') {
      let clase: string;

      switch (row.Status.Codstat) {
        case 'A':
          clase = 'LA-status-A';
          break;

        case 'B':
          clase = 'LA-status-B';
          break;

        case 'D':
          clase = 'LA-status-D';
          break;

        case 'L':
          clase = 'LA-status-L';
          break;

        case 'O':
          clase = 'LA-status-O';
          break;

        case 'P':
          clase = 'LA-status-P';
          break;

        case 'Q':
          clase = 'LA-status-Q';
          break;

        case 'R':
          clase = 'LA-status-R';
          break;

        case 'S':
          clase = 'LA-status-S';
          break;

        case 'Y':
          clase = 'LA-status-Y';
          break;
      }

      return `<i class="fa fa-lightbulb-o LA-size ${clase}"></i> ${data.Numero} - ${data.Analista}`;
      // return '<i class="'fa fa-lightbulb-o '+clase+'></i> '+ data;
    }

    return data;
  }

  DescripcionCompleta: DataTables.FunctionColumnRender = ( data, type, row, meta ) => {
    return data.Descripcorta + '<br>' + data.Descriplarga;
  }

  constructor(
    public dameSistemas: DameSistemas,
    public dameCasos: DameCasos,
    public dameStatusCasos: DameStatusCasos,
    private autenticaCli: AutenticaCli,
    private fb: FormBuilder,
    private colorGrid: ColorGrid
  ) {
    this.dtColumnas = [
      { title: this.colorGrid.tablaH('Num Caso - Analista'), data: null, render: this.IconTabla,
      className: 'details-control', width: '20%' },
      { title: this.colorGrid.tablaH('Fecha Carga'), data: 'Fechacarga' },
      { title: this.colorGrid.tablaH('Sistema'),     data: 'Sistema' },
      { title: this.colorGrid.tablaH('Descripción'), data: null, render: this.DescripcionCompleta },
      { title: this.colorGrid.tablaH('Status / Fecha'), data: 'Status', render: (data: any, type: any, row: any, meta) => {
        return data.Stat + ' ~ ' + data.Fechastatus;
      } }
    ];
  }

  ngOnInit() {
    this.fSistema.valueChanges.subscribe(valor => { this.dameCasos.ParamIn.nuSistema = valor; });
    this.autenticaCli.leerToken();
    this.dameSistemas.consultar();
    // this.dameStatusCasos.consultar();
    for (const estado of this.dameStatusCasos.CadOut) {
      this.frmStatCasos.addControl('Check' + estado.Codigo, this.fb.control(estado.checked) );
      this.frmStatCasos.get('Check' +  estado.Codigo).valueChanges.subscribe(valor => { estado.checked = valor; });
    }

    if (this.dameCasos.ParamIn.desde !== '' && this.dameCasos.ParamIn.hasta !== '') {
      this.desde = fech_a_HTfech(this.dameCasos.ParamIn.desde);
      this.hasta = fech_a_HTfech(this.dameCasos.ParamIn.hasta);
    } else {
      this.desde = fech_a_HTfech(inicio_anno(fechaHoy()));
      this.hasta = HTfechaHoy();
    }

    if (this.dameCasos.ParamIn.nuSistema !== 0) {
      this.fSistema.patchValue(this.dameCasos.ParamIn.nuSistema);
    }

    // this.dameCasos.CadOut = [];
    this.dameCasos.visible = true;
  }

  getBuscar() {
    if (this.desde > this.hasta) {
      swal.fire('Error en Fechas', 'Fecha desde no pude ser mayor a la fecha hasta'  , 'error');
    } else {
      this.dameCasos.visible = false;
      this.dameCasos.ParamIn.nucli = +this.autenticaCli.CadOut.Numcli;

      this.dameCasos.ParamIn.desde = HTfech_a_fech(this.desde);
      this.dameCasos.ParamIn.hasta = HTfech_a_fech(this.hasta);


      this.dameCasos.ParamIn.stat = this.dameStatusCasos.CadOut
          .filter(valor => valor.checked ? valor.Codigo : null)
          .map( valor => valor.Codigo)
          .toString();

      this.dameCasos.consultar();
    }
  }

  // public datos = [
  //   { num: '1', crea: '27/12/2019', statusF: '27/12/2019', drscri: 'Descripcion de Casos: Detalles', status: '---', otro: '---' },
  //   { num: '2', crea: '27/12/2019', statusF: '27/12/2019', drscri: 'Descripcion de Casos: Detalles', status: '---', otro: '---' },
  //   { num: '3', crea: '27/12/2019', statusF: '27/12/2019', drscri: 'Descripcion de Casos: Detalles', status: '---', otro: '---' },
  //   { num: '1', crea: '27/12/2019', statusF: '27/12/2019', drscri: 'Descripcion de Casos: Detalles', status: '---', otro: '---' },
  // ];

  // openModal(id: string) {
  //   this.modalService.open(id);
  // }

  // closeModal(id: string) {
  //   this.modalService.close(id);
  // }
}
